import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminProductElementsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('product-element');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
